module.exports = __webpack_public_path__ + "img/bgtop.56ee942d.jpg";